<template>
  <div class="w-full h-full flex flex-col overflow-auto overflow-x-hidden">
    <div class="flex p-8 pt-4 items-center gap-4 border-b border-neutral-200">
      <div class="min-w-10 w-10 h-10 overflow-hidden rounded-xl">
        <ImgComponent class="" src="/logo.png" alt="Logo" />
      </div>
      <div
        class="text-xl title-color whitespace-nowrap duration-300"
        :class="{ 'opacity-0': collapsed }"
      >
        Dashboard
      </div>
    </div>
    <div class="py-2"></div>
    <div class="tourguidEl menuNavs">
      <div
        class="p-4 py-0"
        v-for="(nav, i) in [
          { name: 'Accueil', icon: 'home.svg', id: '/home' },
          { name: 'Transactions', icon: 'history.svg', id: '/history' },
          { name: 'Clients', icon: 'user.svg', id: '/customers' },
          { name: 'Administrateurs', icon: 'admin.svg', id: '/admins' },
          { name: 'Publicités', icon: 'ads.png', id: '/ads' },
          // { name: 'Coupons', icon: 'Ticket_use_fill.svg', id: '/coupons' },
          { name: 'Frais', icon: 'fees.png', id: '/fees' },
          { name: 'Notifications', icon: 'bell.svg', id: '/notifications' },
          { name: 'Réglages', icon: 'setting.svg', id: '/setting' },
          {
            name: 'Déconnexion',
            icon: 'logout.svg',
            event: $constants.EVENTS.USER.LOGOUT
          }
        ]"
        :key="i"
        :permission="nav.permission || 'none'"
      >
        <component
          :is="nav.id ? 'router-link' : 'div'"
          :to="nav.id"
          class="flex p-4 items-center gap-4 ripple rounded-full"
          @click="
            () => {
              nav.event && $bus.emit(nav.event);
              $emit('navClicked');
            }
          "
          :class="[{ 'bg-white ': nav.id?.includes($route.name) }]"
        >
          <div class="min-w-7 w-7 h-7">
            <ColorImg
              :src="`/images/navs/${nav.icon}`"
              alt=""
              class="bg-primary w-full h-full"
            />
          </div>
          <div
            class="title-color whitespace-nowrap duration-300"
            :class="{ 'opacity-0': collapsed }"
          >
            {{ nav.name }}
          </div>
        </component>
      </div>
    </div>
    <div class="py-8"></div>
  </div>
</template>

<script setup>
const emit = defineEmits(['navClicked']);
defineProps({ collapsed: { type: Boolean, default: true } });
</script>
